module.exports = __webpack_public_path__ + "img/wifi.71de0198.svg";